// extracted by mini-css-extract-plugin
export default {"backbarComponent":"BackBar_backbarComponent__84-Cu","backbarTitle":"BackBar_backbarTitle__cmrJX","backiconStyle":"BackBar_backiconStyle__6Vxqw"};